import React from 'react';
import { Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

export default function CountDownTimer({ countDownTime, countdownActive }) {
  const [seconds, setSeconds] = React.useState(countDownTime);

  React.useEffect(() => {
    if (countdownActive && seconds > 0) {
      setTimeout(() => {
        setSeconds(prev => prev - 1);
      }, 1000);
    }

    if (!countdownActive) {
      setSeconds(countDownTime)
    }
  }, [seconds, countdownActive]);

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const remainingSeconds = timeInSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
  };
  return (
    <Typography type="body" scale={100} bold component="span" id='countdown-timer'>
      {formatTime(seconds)}
    </Typography>
  );
}
